var form = require('./form.ejs');

export default { form };
